import React from 'react';
import { Plus } from 'lucide-react';
import { IntakeForm } from '../../components/IntakeRecords/IntakeForm';
import { IntakeList } from '../../components/IntakeRecords/IntakeList';
import { ActionBar } from '../../components/ActionBar';
import { useIntakeRecords } from './hooks/useIntakeRecords';

export const IntakeRecordsPage: React.FC = () => {
  const {
    records,
    showForm,
    editingRecord,
    handleSubmit,
    handleEdit,
    handleDelete,
    handleCancel,
    handleClear,
    handleExport,
    handleImport,
    setShowForm
  } = useIntakeRecords();

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Intake Records</h1>
        <button
          onClick={() => setShowForm(true)}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
        >
          <Plus className="w-5 h-5" />
          Add Record
        </button>
      </div>

      <ActionBar
        onClear={handleClear}
        onExport={handleExport}
        onImport={handleImport}
        onSample={handleImport}
        sampleUrl='https://raw.githubusercontent.com/peptidenow/sample-data/refs/heads/main/intake_records.csv'
      />

      {showForm ? (
        <div className="mb-8">
          <IntakeForm
            onSubmit={handleSubmit}
            initialData={editingRecord}
            onCancel={handleCancel}
          />
        </div>
      ) : (
        <IntakeList
          records={records}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      )}
    </div>
  );
};